/* eslint-disable */
import React, { Component } from 'react';
import { connect } from "react-redux";
import Layout from '@components/shared/layout';
import { getPrestador, updatePrestador, getProfissionaisExecutantesFiltered } from '@store/actions';
import AccordionGroup from '@components/accordion_group';
import AccordionChild from '@components/accordion_child';
import CustomSnackbar from '@components/shared/custom_snackbar';
import TableProfissionais from '@components/profissionais_executantes/table_profissionais';
import FormFiltro from '@components/profissionais_executantes/form_filtro';
import AjaxLoader from '@components/shared/ajax_loader';
import m from '@utils/strings';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import '@styles/profissionais-executantes.css'
import userManager from '@utils/userManager';

class ProfissionaisExecutantes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeKey: '1',
            snackbarType: 'error',
            snackbarMsg: '',
            showPrestadorLoader: false,
        }
        setTimeout(() => {
            this.applyFilter(null);
        }, 600);
    }
    
    verifiyIfUserIsAuthenticated = () => {
        const { user } = this.props
        if (!user || user.expired) {
            userManager.signinRedirect();
        }
    }

    getUpdatePrestador = () => {
        const { user } = this.props
        if (user != null && user.profile != null) {
            if (!this.isFetchingPrestador) {
                this.isFetchingPrestador = true;
                let cpfCnpj = user.profile.prestador instanceof Array ? user.profile.prestador[0] : user.profile.prestador
                this.props.getPrestador(cpfCnpj, (result) => {
                    this.props.updatePrestador(result);
                    this.setState({ showPrestadorLoader: false });
                });
            }
        }
    }

    componentDidUpdate() {
        this.verifiyIfUserIsAuthenticated();
    }

    componentDidMount() {
        if(_.isEmpty(this.props.prestador)) {
            this.setState({ showPrestadorLoader: true });
            this.getUpdatePrestador();
        }  
        this.verifiyIfUserIsAuthenticated();
        document.addEventListener("keydown", this.handleKeyDown, false);
        this.focusFirstField();

        const { location } = this.props; 

        if (location && location.state) {
            this.callSnackbar(location.state.messageResponse, location.state.statusResponse);
        }   
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown, false);
    }

    handleKeyDown = (event) => {
        if(event.key == 'F7' && this.state.activeKey == '1'){
            this.setState({ activeKey: '' });
        }
        else if (event.key == 'F7') {
            this.focusFirstField();
            this.setState({ activeKey: '1' });
        }
    }

    handleAccordionSelect = (activeKey) => {
        if(this.state.activeKey === '1'){
            this.setState({ activeKey: '' });
        }
        else {
            this.focusFirstField();
            this.setState({ activeKey: '1' });
        }
    }

    callSnackbar = (snackbarMsg, snackbarType) => {
        this.setState({ snackbarMsg });
        this.setState({ snackbarType });
        this.click();
    }

    applyFilter = (params) => {
        if(_.isEmpty(this.props.prestador)) {
            setTimeout(() => {
                this.applyFilter(params);
            }, 600);
            return ;
        }
        this.applyFilterTable(params)
    }

    render() {
        const { user } = this.props;
        const { showPrestadorLoader } = this.state;
        
        const prestadorLoader = showPrestadorLoader? <AjaxLoader ajaxMessage={m.TELA_PROFISSIONAIS_EXECUTANTES.MENSAGEM_LOADER_BUSCANDO_PRESTADOR} /> : '';
        
        return (
            <div>
                {prestadorLoader}
                <Layout
                    user={user}
                    iconePath=""
                    content={m.TELA_PROFISSIONAIS_EXECUTANTES.TITULO_PAGINA}
                />
                <Link to='/cadastrar-editar-profissional' className='button-cadastrar-novo-label'>
                    <div className='button-cadastrar-novo'>
                        {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_CADASTRAR_NOVO}
                    </div>
                </Link>
                <AccordionGroup 
                    withoutLateralMenu={true}
                    activeKey={this.state.activeKey}
                    onSelect={this.handleAccordionSelect}
                    childs={[
                        <AccordionChild 
                            componentToRender={
                                <FormFiltro 
                                    callSnackbar={this.callSnackbar}
                                    applyFilter={this.applyFilter}
                                    focusFirstField={e => this.focusFirstField = e}
                                    activeAccordion={this.state.activeKey}
                                />
                            }
                            title={m.TELA_GERACAO_LOTE_COBRANCA.TITULO_ACCORDION}
                            keyboardCommandKey="F7"
                            keyAccordion="1"
                            key="1"
                        />
                    ]}
                />
                <TableProfissionais 
                    updateTableRows={e => this.updateTableRows = e} 
                    updateApplyingFilter={e => this.updateApplyingFilter = e}
                    applyFilterTable={e => this.applyFilterTable = e}
                    callSnackbar={this.callSnackbar}
                    prestador={this.props.prestador}
                    resetGuiasSelecionadas={e => this.resetGuiasSelecionadas = e}
                    getProfissionaisExecutantesFiltered={this.props.getProfissionaisExecutantesFiltered}
                />
                <div className='div-separador-25' />
                <CustomSnackbar
                    setClick={click => this.click = click}
                    variant={this.state.snackbarType}
                    duration={2500}
                    content={this.state.snackbarMsg}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        prestador: state.prestador
    }
}


export default connect(mapStateToProps, { getPrestador, updatePrestador, getProfissionaisExecutantesFiltered })(ProfissionaisExecutantes);